import {Injectable} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {filter} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UserLocationService {

  private static readonly USA_GEO_CENTER = {latitude: 44.967243, longitude: -103.771556};

  private readonly userLocationSubject = new ReplaySubject<UserLocation>(1);
  public readonly userLocation$: Observable<UserLocation> = this.userLocationSubject.asObservable()
    .pipe(filter(location => location !== undefined));
  private _userLocation: UserLocation = UserLocationService.USA_GEO_CENTER;

  constructor() {
    this.registerUserLocationWatcher();
  }

  registerUserLocationWatcher(): void {
    if (window.navigator?.geolocation) {
      window.navigator.geolocation.getCurrentPosition((position) => {
        this._userLocation = {latitude: position.coords.latitude, longitude: position.coords.longitude} as UserLocation;
        this.userLocationSubject.next(this._userLocation);
      }, (error) => {
        this.userLocationSubject.next(this._userLocation);
      });
    } else {
      this.userLocationSubject.next(this._userLocation);
    }
  }

  public getUserLocation(): UserLocation {
    return this._userLocation;
  }

}

export interface UserLocation {
  latitude: number;
  longitude: number;
}
